import moment from 'moment';

export default class calc {

    static get(daysInFuture, state) {
        if(!state.data) return {
            transactions: [],
            balance: 0
        };

        let balance         = state.data.balance || 0;
        let transactions    = this.getTransactions(daysInFuture, state);

        return {
            transactions: transactions.reverse(),
            balance: balance + this.getTransactionTotal(transactions)
        };
    }

    static getTransactions(daysInFuture, state) {
        let transactions    = [];

        // Loop through each day, adding transactions of that day.
        for(let i = 1; i <= daysInFuture; i++) {
            let futureDay = moment().add(i, 'days').startOf('day');

            // Any single income today?
            let singleIncome = this.getSingleTransactions(futureDay,
                state.data.incomeSingle, 'add');
            transactions = transactions.concat(singleIncome);

            // Any single expenses today?
            let singleExpenses = this.getSingleTransactions(futureDay,
                state.data.expensesSingle, 'subtract');
            transactions = transactions.concat(singleExpenses);

            // Any monthly income today?
            let monthlyIncome = this.getRepeatingTransactions(futureDay,
                state.data.incomeMonth, 'add');
            transactions = transactions.concat(monthlyIncome);

            // Any monthly expenses today?
            let monthlyExpenses = this.getRepeatingTransactions(futureDay,
                state.data.expensesMonth, 'subtract');
            transactions = transactions.concat(monthlyExpenses);
        }

        return transactions;
    }

    static getSingleTransactions(onDay, transactionData, operator) {
        let transactions = [];
        for(let transactionId in transactionData) {
            // Because we're adding calc property, duplicate object.
            let entry = JSON.parse(JSON.stringify(transactionData[transactionId]));

            if(!entry.count) continue;

            let entryDate = moment(entry.date, 'YYYYMMDD');
            if(entryDate.isSame(onDay)) {
                entry.calc = operator;
                transactions.push(entry);
            }
        }
        return transactions;
    }

    static getRepeatingTransactions(onDay, transactionData, operator) {
        let transactions = [];
        for(let transactionId in transactionData) {
            // Because we're adding calc property, duplicate object.
            let entry = JSON.parse(JSON.stringify(transactionData[transactionId]));

            if(!entry.count) continue;

            if(entry.day === parseInt(onDay.format('D'), 10)) {
                entry.calc = operator;
                transactions.push(entry);
            }
        }
        return transactions;
    }

    static getTransactionTotal(transactions) {
        let total = 0;
        for(let i = 0; i < transactions.length; i++) {
            if(transactions[i].calc === 'add') {
                total += transactions[i].amount;
            } else {
                total -= transactions[i].amount;
            }
        }
        return total;
    }
}


// WEBPACK FOOTER //
// ./src/services/calc.js